export default __webpack_public_path__ + "static/media/gradient-background.66d1fc62.svg";